/**
 * ArkUI.Drawer - 抽屉组件辅助函数
 */

// 检测是否移动端
function isMobile() {
    // 检查触摸支持 + 屏幕宽度
    const hasTouchScreen = (
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
    );
    const isSmallScreen = window.innerWidth < 768;
    
    // 也检查 userAgent 作为后备
    const mobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    return (hasTouchScreen && isSmallScreen) || mobileUA;
}

// 检测是否在 MAUI WebView 环境中
function isMauiWebView() {
    // MAUI Blazor 使用 https://0.0.0.0 或 app:// 协议
    return window.location.origin === 'https://0.0.0.0' ||
           window.location.protocol === 'app:' ||
           window.location.hostname === '0.0.0.0';
}

// 锁定/解锁 body 滚动
let scrollLockCount = 0;
let originalBodyStyle = '';

function lockBodyScroll(lock) {
    // MAUI WebView 中不需要锁定 body 滚动
    // position: fixed 会导致 Android WebView 布局异常
    if (isMauiWebView()) return;

    if (lock) {
        scrollLockCount++;
        if (scrollLockCount === 1) {
            // 保存原始样式
            originalBodyStyle = document.body.style.cssText;
            
            // 获取当前滚动位置
            const scrollY = window.scrollY;
            
            // 锁定 body
            document.body.style.cssText = `
                ${originalBodyStyle};
                position: fixed;
                top: -${scrollY}px;
                left: 0;
                right: 0;
                overflow: hidden;
            `;
            
            // 保存滚动位置
            document.body.dataset.scrollY = scrollY;
        }
    } else {
        scrollLockCount = Math.max(0, scrollLockCount - 1);
        if (scrollLockCount === 0) {
            // 恢复原始样式
            const scrollY = parseInt(document.body.dataset.scrollY || '0');
            document.body.style.cssText = originalBodyStyle;
            
            // 恢复滚动位置
            window.scrollTo(0, scrollY);
            
            delete document.body.dataset.scrollY;
            originalBodyStyle = '';
        }
    }
}

// 使用 requestAnimationFrame 确保 DOM 就绪后执行回调
// 这是解决动画失效的关键：确保浏览器完成一次渲染后再触发动画
function requestAnimationFrame(dotNetRef, methodName) {
    // 双重 RAF 确保浏览器完成布局和绘制
    window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
            if (dotNetRef && methodName) {
                dotNetRef.invokeMethodAsync(methodName);
            }
        });
    });
}

// 边缘滑动检测（用于从边缘滑动打开抽屉）
let edgeSwipeHandlers = new Map();

function enableEdgeSwipe(anchor, callback) {
    const edgeThreshold = 20; // 边缘区域宽度
    let startX = 0;
    let startY = 0;
    let isEdgeSwipe = false;
    
    const handleTouchStart = (e) => {
        if (e.touches.length !== 1) return;
        
        const touch = e.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;
        
        // 检测是否从边缘开始
        const isFromEdge = anchor === 'left' ? startX < edgeThreshold :
                          anchor === 'right' ? startX > window.innerWidth - edgeThreshold :
                          anchor === 'top' ? startY < edgeThreshold :
                          anchor === 'bottom' ? startY > window.innerHeight - edgeThreshold :
                          false;
        
        isEdgeSwipe = isFromEdge;
    };
    
    const handleTouchMove = (e) => {
        if (!isEdgeSwipe || e.touches.length !== 1) return;
        
        const touch = e.touches[0];
        const deltaX = touch.clientX - startX;
        const deltaY = touch.clientY - startY;
        
        // 检测滑动方向是否正确
        const isCorrectDirection = 
            anchor === 'left' ? deltaX > 50 :
            anchor === 'right' ? deltaX < -50 :
            anchor === 'top' ? deltaY > 50 :
            anchor === 'bottom' ? deltaY < -50 :
            false;
        
        if (isCorrectDirection) {
            isEdgeSwipe = false;
            callback();
        }
    };
    
    const handleTouchEnd = () => {
        isEdgeSwipe = false;
    };
    
    document.addEventListener('touchstart', handleTouchStart, { passive: true });
    document.addEventListener('touchmove', handleTouchMove, { passive: true });
    document.addEventListener('touchend', handleTouchEnd, { passive: true });
    
    const cleanup = () => {
        document.removeEventListener('touchstart', handleTouchStart);
        document.removeEventListener('touchmove', handleTouchMove);
        document.removeEventListener('touchend', handleTouchEnd);
    };
    
    edgeSwipeHandlers.set(anchor, cleanup);
    return true;
}

function disableEdgeSwipe(anchor) {
    const cleanup = edgeSwipeHandlers.get(anchor);
    if (cleanup) {
        cleanup();
        edgeSwipeHandlers.delete(anchor);
    }
}

// 导出到全局
if (typeof window !== 'undefined') {
    window.ArkUI = window.ArkUI || {};
    Object.assign(window.ArkUI, {
        isMobile,
        lockBodyScroll,
        requestAnimationFrame,
        enableEdgeSwipe,
        disableEdgeSwipe
    });
}

export { isMobile, lockBodyScroll, requestAnimationFrame, enableEdgeSwipe, disableEdgeSwipe };
